import { render, staticRenderFns } from "./PurchaseOrdersViewTable.vue?vue&type=template&id=92617bfc&scoped=true&"
import script from "./PurchaseOrdersViewTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrdersViewTable.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrdersViewTable.vue?vue&type=style&index=0&id=92617bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92617bfc",
  null
  
)

export default component.exports